module.exports = __webpack_public_path__ + "img/tt-1.cec0be9f.png";